import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IGetOneWishListPayload } from '@app-store/slices/wishLists/oneWishList'

interface TaskAction extends Action {
    payload: IGetOneWishListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.wishLists.oneWishList
function* oneWishListSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/wish-lists/one/${payload?.id || 'default'}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneWishListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneWishListSagaTask)
}

export default oneWishListSaga
